import React from "react";

interface IconProps {
  fill: string;
  title: string;
}
const PlaceholderSymbol: React.FC<IconProps> = (props: IconProps) => (
  <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 480 480" fill={props.fill}>
    <title>{props.title}</title>
    <g>
      <g>
        <g>
          <path
            d="M207.849,363.632c4.652,3.441,16.873,21.796,26.722,40.23c1.745,3.266,5.143,5.288,8.818,5.288
				c0.165,0,0.33-0.004,0.495-0.012c3.863-0.191,7.271-2.593,8.749-6.167c7.479-18.089,17.505-36.252,21.906-39.797
				c86.216-16.434,148.68-91.953,148.68-179.954C423.219,82.191,341.027,0,240,0S56.781,82.191,56.781,183.219
				c0,43.477,15.504,85.632,43.657,118.701C128.042,334.346,166.148,356.232,207.849,363.632z M240,20
				c89.999,0,163.219,73.22,163.219,163.219c0,78.694-56.064,146.183-133.315,160.475c-5.83,1.083-12.902,5.315-25.073,28.752
				c-0.845,1.628-1.663,3.248-2.444,4.83c-1.078-1.78-2.208-3.613-3.374-5.457c-13.621-21.548-20.562-26.667-26.776-27.721
				c-78.488-13.462-135.456-81.121-135.456-160.877C76.781,93.22,150.001,20,240,20z"
          />
          <path
            d="M321.907,371.244c-5.387-1.208-10.736,2.184-11.944,7.573c-1.207,5.389,2.183,10.737,7.573,11.944
				c38.87,8.706,56.574,22.029,56.574,30.724c0,5.96-9.235,16.039-35.263,24.832C312.726,455.141,277.8,460,240.501,460
				c-37.309,0-72.242-4.859-98.364-13.684c-26.03-8.793-35.266-18.872-35.266-24.832c0-8.012,15.83-20.592,50.585-29.283
				c5.358-1.34,8.615-6.769,7.275-12.127c-1.34-5.358-6.77-8.615-12.127-7.275c-42.389,10.599-65.733,27.89-65.733,48.686
				c0,12.442,8.478,30.138,48.865,43.78C163.867,474.767,201.074,480,240.501,480c39.418,0,76.618-5.233,104.746-14.735
				c40.385-13.643,48.862-31.338,48.862-43.78C394.109,399.515,368.467,381.673,321.907,371.244z"
          />
        </g>
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

export default PlaceholderSymbol;
